exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".column-checklist[data-v-2c28e0b8] {\n  overflow-y: auto;\n}", ""]);

// exports
